import React, { useState } from "react";
import { Minus, Plus, Trash2 } from 'lucide-react';
import { foodItemTypes, foodItems, cartItemsData } from "./data/posData";
import pos_icon1 from "../../../../assets/images/round-table-icon2.svg"
import pos_icon2 from "../../../../assets/images/meeting-room-icon.svg"
import receipt_icon from "../../../../assets/images/receipt-icon.svg"
import cash_icon from "../../../../assets/images/cash-icon.svg"
import upi_icon from "../../../../assets/images/upi-icon.svg"

const POS = () => {

    const [cartItems, setCartItems] = useState([...cartItemsData])

    const handleIncrement = (id) => {
        setCartItems(prev => prev.map(item =>
            item.id === id ? { ...item, quantity: item.quantity + 1 } : item
        ));
    };

    const handleDecrement = (id) => {
        setCartItems(prev => prev.map(item =>
            item.id === id && item.quantity > 1
                ? { ...item, quantity: item.quantity - 1 }
                : item
        ));
    };

    const handleDelete = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    const [selectedPayment, setSelectedPayment] = useState('pay-later');

    const subtotal = 512.00;
    const tax = 18.2;
    const total = subtotal + tax;

    const paymentMethods = [
        { id: 'pay-later', label: 'Pay Later', icon: receipt_icon },
        { id: 'cash', label: 'Cash', icon: cash_icon },
        { id: 'pay-online', label: 'Pay Online', icon: upi_icon }
    ];


    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="fw-bold mb-0">POS</h3>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="row g-2 list-unstyled li_animate row-cols-lg-6 row-cols-md-3 row-cols-sm-2 row-cols-1 row-deck mb-lg-2 mb-4">
                        {foodItemTypes.map((data, index) => {
                            return (
                                <li className="col" key={index}>
                                    <div className="card pos-cards h-100">
                                        <div className="pos-cards-img-div">
                                            <img src={data.item_image} className="pos-cards-img" alt="pos-cards-img" />
                                        </div>
                                        <div className="pos-cards-content">
                                            <div>
                                                <h6 className="pos-cards-title1 m-0">{data.item_type}</h6>
                                                <small className="pos-cards-small">Check Menu</small>
                                            </div>
                                            <button className="btn pos-cards-btn">Order</button>
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </div>
                </div>
                <div className="col-sm-12">
                    <h5 className="fs-3 fw-bold my-3" style={{ color: "#172736" }}>Breakfast</h5>
                    <div className="row g-2 list-unstyled li_animate row-deck mb-lg-2 mb-4">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="row g-2 list-unstyled li_animate row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-1 row-deck">
                                {foodItems.map((item) => {
                                    return [...Array(4)].map((_, i) => (
                                        <div className="col" key={`${item.id}-${i}`}>
                                            <div className="card pos-cards2">
                                                <div className="pos-cards2-img-align">
                                                    <img src={item.meal_type.item_image} className="pos-cards-img2" alt="item_image" />
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center p-2">
                                                    <div className="">
                                                        <h5 className="pos-card-title2 m-0">{item.meal_type.item_name}</h5>
                                                        <small className="pos-cards-small2">{item.meal_type.price}</small>
                                                    </div>
                                                    <button className="btn pos-cards-btn">ADD</button>
                                                </div>
                                            </div>
                                        </div>
                                    ));
                                })}
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="card p-2 h-100">
                                <div className="d-flex gap-2">
                                    <button className="btn w-100 fw-semibold pos-cards2-btn-primary">
                                        <img src={pos_icon1} className="me-2" alt="pos_icon1" style={{ height: "70%" }} />
                                        Table
                                    </button>
                                    <button className="btn w-100 fw-semibold pos-cards2-btn-secondary">
                                        <img src={pos_icon2} className="" alt="pos_icon2" style={{ height: "70%" }} />
                                        Room
                                    </button>
                                </div>
                                <input type="text" className="form-control py-3 mt-2" value="T-002" />
                                <div>
                                    <div className="cart-container">
                                        {cartItems.length === 0 ? (
                                            <div className="empty-cart">Your cart is empty</div>
                                        ) : (
                                            cartItems.map((item) => (
                                                <div key={item.id} className="meal-cart-item">
                                                    {/* Left side - Image and Details */}
                                                    <div className="meal-content">
                                                        <img
                                                            src={item.image}
                                                            alt={item.name}
                                                            className="meal-image"
                                                        />


                                                        <div className="meal-details">
                                                            <h5 className="meal-details-item-h5 m-0">{item.name}</h5>
                                                            <p className="m-0">₹ {(item.price * item.quantity).toFixed(2)}</p>
                                                        </div>
                                                    </div>

                                                    {/* Right side - Controls */}
                                                    <div className="meal-controls">
                                                        {/* Decrement Button */}
                                                        <button
                                                            onClick={() => handleDecrement(item.id)}
                                                            disabled={item.quantity <= 1}
                                                            className="control-btn"
                                                        >
                                                            <Minus size={18} strokeWidth={2.5} color="#111827" />
                                                        </button>

                                                        {/* Quantity Display */}
                                                        <span className="quantity-display">
                                                            {item.quantity.toString().padStart(2, '0')}
                                                        </span>

                                                        {/* Increment Button */}
                                                        <button
                                                            onClick={() => handleIncrement(item.id)}
                                                            className="control-btn increment-btn"
                                                        >
                                                            <Plus size={18} strokeWidth={2.5} color="white" />
                                                        </button>

                                                        {/* Delete Button */}
                                                        <button
                                                            onClick={() => handleDelete(item.id)}
                                                            className="control-btn delete-btn"
                                                        >
                                                            <Trash2 size={18} strokeWidth={2} color="#111827" />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                                <div className="payment-container">
                                    {/* Payment Summary */}
                                    <div className="payment-summary">
                                        <h4>Payment Summary</h4>

                                        <div className="summary-row">
                                            <span className="summary-label">Sub total</span>
                                            <span className="summary-value">₹{subtotal.toFixed(2)}</span>
                                        </div>

                                        <div className="summary-row">
                                            <span className="summary-label">Tax</span>
                                            <span className="summary-value">₹{tax.toFixed(1)}</span>
                                        </div>

                                        <div className="divider"></div>

                                        <div className="total-row">
                                            <span className="total-label">Total Payment</span>
                                            <span className="total-value">₹{total.toFixed(1)}</span>
                                        </div>
                                    </div>

                                    {/* Payment Methods */}
                                    <div className="payment-methods">
                                        {paymentMethods.map((method) => {
                                            const Icon = method.icon;
                                            return (
                                                <button
                                                    key={method.id}
                                                    className={`payment-method ${selectedPayment === method.id ? 'selected' : ''}`}
                                                    onClick={() => setSelectedPayment(method.id)}
                                                >
                                                    <div className="payment-icon">
                                                        {/* <Icon size={40} strokeWidth={1.5} /> */}
                                                        <img src={Icon} className="" style={{ height: "60%" }} alt="paymemt-icons" />
                                                    </div>
                                                    <span className="payment-label text-nowrap">{method.label}</span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                                <button className="btn pos-order-btn">Place An Order</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default POS